import React from 'react';

import GridContainer from 'components/Grid/GridContainer.js';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import Badge from 'components/Badge/Badge';
import { formatDate } from 'hooks/Pipe';
import RegularButton from 'components/CustomButtons/Button';
import LogsModal from 'components/Tvendo/Common/LogsModal';
import { useModal } from 'hooks/useModal';
import UpdateImageModal from '../../UpdateImageModal';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

export default function ReadResume(props) {
  const { dataProduct, showNotify, reload } = props;
  const [model, setOpen] = useModal();
  const [imageModel, setImageOpen] = useModal();

  return (
    <>
      <LogsModal
        model={model}
        setOpen={setOpen}
        logName="logi_products"
        subjectId={dataProduct.id}
      />
      <UpdateImageModal
        model={imageModel}
        setOpen={setImageOpen}
        showNotify={showNotify}
        setProducts={reload}
      />
      <GridItem xs={12} sm={12} md={4}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Principal</h4>
            {dataProduct.image_sales_path !== null && (
              <div
                style={{ width: 150, maxHeight: 150, overflow: 'hidden', cursor: 'pointer' }}
                onClick={() => setOpen(dataProduct)}
              >
                <img src={dataProduct.image_sales_path} style={{ width: '100%' }} />
              </div>
            )}
            <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_UPDATE}>
              {dataProduct.image_sales_path === null && (
                <Button color="warning" onClick={() => setImageOpen(dataProduct)}>
                  Actualizar imagen
                </Button>
              )}
            </AllowedGuard>
          </CardHeader>
          <CardBody>
            <h6>Código SAP</h6>
            <p>{dataProduct.ItemCode || '-'}</p>
            <h6>Código externo</h6>
            <p>{dataProduct.FrgnName || '-'}</p>
            <h6>Código externo 2</h6>
            <p>{dataProduct.FrgnName2 || '-'}</p>
            <h6>Producto de Origen</h6>
            <p>{`${dataProduct.ItemNameOrigin || '-'} (${dataProduct.ItemCodeOrigin || '-'})`}</p>
            <h6>Proveedor</h6>
            <p>{`${dataProduct.CardName || '-'} (${dataProduct.CardCode || '-'})`}</p>
            <h6>Nombre de artículo</h6>
            <p>{dataProduct.ItemName || '-'}</p>
            <h6>Tipo de artículo</h6>
            <p>
              {dataProduct.ItemType == 'I'
                ? 'Artículo'
                : dataProduct.ItemType == 'L'
                ? 'Trabajo'
                : dataProduct.ItemType == 'T'
                ? 'Viaje'
                : 'Activo fijo'}
            </p>
            <h6>Bonificación</h6>
            <p>{dataProduct.QryGroup1 === 'Y' ? 'Si' : 'No' || '-'}</p>
            <h6>Estado</h6>
            <Badge color={dataProduct.state == 'A' ? 'success' : 'warning'}>
              {dataProduct.state == 'A' ? 'Activo' : 'Inactivo'}
            </Badge>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={8}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Categorías</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={4}>
                <h6>Modelo</h6>
                <p>{dataProduct.U_SYP_MODELO || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Categoría</h6>
                <p>{dataProduct.logi_category_description || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Línea</h6>
                <p>{dataProduct.logi_line_description || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Familia</h6>
                <p>{dataProduct.logi_family_description || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Sub-Familia</h6>
                <p>{dataProduct.logi_sub_family_description || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Marca</h6>
                <p>{dataProduct.logi_mark_description || '-'}</p>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 style={{ color: 'black' }}>Grupo</h4>
              </CardHeader>
              <CardBody>
                <h6>Grupo de artículos</h6>
                <p>{dataProduct.ItmsGrpNam || '-'}</p>
                <h6>Grupo de unidades de medida</h6>
                <p>{dataProduct.UgpEntry_UgpName || '-'}</p>
                <h6>Lista de Precio</h6>
                <p>{dataProduct.ListName || '-'}</p>
                {dataProduct?.CardCode === 'P20255172884' ? (
                  <>
                    <h6>Grupo para reporte diario</h6>
                    <p>{dataProduct.group[0]?.group_description || '-'}</p>
                  </>
                ) : null}
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 style={{ color: 'black' }}>Otros</h4>
              </CardHeader>
              <CardBody>
                <h6>Código de Barras</h6>
                <p>{dataProduct.ListName || '-'}</p>
                <h6>Activo para compra</h6>
                <p>
                  {dataProduct.PrchseItem === 'Y'
                    ? 'Si'
                    : dataProduct.PrchseItem === 'N'
                    ? 'No'
                    : '-'}
                </p>
                <h6>Activo para venta</h6>
                <p>
                  {dataProduct.SellItem === 'Y' ? 'Si' : dataProduct.SellItem === 'N' ? 'No' : '-'}
                </p>
                <h6>Listado en venta</h6>
                <p>
                  {dataProduct.SellItem === 'Y' && dataProduct.disable_sales_listing === false
                    ? 'Si'
                    : 'No'}
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12}>
            <GridContainer>
              <GridItem xs={3}>
                <h6>Fecha de creación</h6>
                <p>{formatDate(dataProduct.created_at)}</p>
              </GridItem>
              <GridItem xs={3}>
                <h6>Fecha de modificación</h6>
                <p>{formatDate(dataProduct.updated_at)}</p>
              </GridItem>
              <GridItem xs={4}>
                <h6>Usuario que Modifica</h6>
                <p>{dataProduct?.updated_by_user?.name || '--'}</p>
              </GridItem>
              <GridItem xs={2}>
                <RegularButton onClick={setOpen} color="warning">
                  Ver logs
                </RegularButton>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </GridItem>
    </>
  );
}
